import React from "react";
import {
  BaseGetTradeExtraInfoDataRequest,
  FormattedChartDataPoint,
  GetTradeExtraInfoConfigurationResponse,
  GetTradeExtraInfoGeneralResponse,
  GetTradeExtraInfoOrdersGraphResponse,
  GetTradeExtraInfoOrdersResponse,
  GridCardData,
  LineAnnotation,
  PointAnnotation,
  QueryStatus,
  TimeRange,
  TradeExtraInfoActivity,
  TradeExtraInfoStats,
  TradeMetadata,
} from "@shared/types";
import { SkipToken } from "@reduxjs/toolkit/query";

export const TradeDetailsContext = React.createContext<
  | {
      isBotDrawer?: boolean;
      baseArgs: BaseGetTradeExtraInfoDataRequest | SkipToken;
      getTradeExtraInfoOrdersStatus: QueryStatus<GetTradeExtraInfoOrdersResponse>;
      ordersData: GetTradeExtraInfoOrdersResponse | undefined;
      getTradeExtraInfoGeneralStatus: QueryStatus<GetTradeExtraInfoGeneralResponse>;
      generalData: GetTradeExtraInfoGeneralResponse | undefined;
      getTradeExtraInfoActivitiesStatus: QueryStatus<TradeExtraInfoActivity[]>;
      activities: TradeExtraInfoActivity[] | undefined;
      getTradeExtraInfoConfigurationStatus: QueryStatus<GetTradeExtraInfoConfigurationResponse>;
      configurationData: GetTradeExtraInfoConfigurationResponse | undefined;
      getTradeExtraInfoOrdersGraphStatus: QueryStatus<GetTradeExtraInfoOrdersGraphResponse>;
      graphData?: FormattedChartDataPoint[];
      getTradeExtraInfoStatsStatus: QueryStatus<TradeExtraInfoStats>;
      statsData: TradeExtraInfoStats | undefined;
      getTradeExtraInfoGridsStatus: QueryStatus<GridCardData[]>;
      gridCardsData: GridCardData[] | undefined;
      getTradeMetadataStatus: QueryStatus<TradeMetadata>;
      tradeMetadata: TradeMetadata | undefined;
      currentTradeMetadata: TradeMetadata | undefined;
      symbol?: string;
      exchange?: string;
      activitiesAnnotations: PointAnnotation[];
      ordersAnnotations: LineAnnotation[];
      closestOrdersAnnotations: LineAnnotation[] | undefined;
      timelineAnnotations: (PointAnnotation | LineAnnotation)[];
      ordersTabAnnotations: (PointAnnotation | LineAnnotation)[];
      pricePrecision?: number;
      amountPrecision?: number;
      refetchOrdersData: () => void;
      timeRange: TimeRange;
      setTimeRange: (timeRange: TimeRange) => void;
      graphChangeValues: { value: number; percent: number };
      isGridBotTrade: boolean;
      isBacktesting?: boolean;
    }
  | undefined
>(undefined);
